<!--<table>
    <tr>
        <td><b>Dia</b></td>
        <td style="text-align: center;"><b>Inicio Jornada</b></td>
        <td style="text-align: center;"><b>Termino Jornada</b></td>
    </tr>
<tr>
    <td>Lunes</td>
    <td style="text-align: center;">{{horarios.lunes.inicio}}</td>
    <td style="text-align: center;">{{horarios.lunes.fin}}</td>
</tr>
<tr>
    <td>Martes</td>
    <td style="text-align: center;">{{horarios.martes.inicio}}</td>
    <td style="text-align: center;">{{horarios.martes.fin}}</td>
</tr>
<tr>
    <td>Miercoles</td>
    <td style="text-align: center;">{{horarios.miercoles.inicio}}</td>
    <td style="text-align: center;">{{horarios.miercoles.fin}}</td>
</tr>
<tr>
    <td>Jueves</td>
    <td style="text-align: center;">{{horarios.jueves.inicio}}</td>
    <td style="text-align: center;">{{horarios.jueves.fin}}</td>
</tr>
<tr>
    <td>Viernes</td>
    <td style="text-align: center;">{{horarios.viernes.inicio}}</td>
    <td style="text-align: center;">{{horarios.viernes.fin}}</td>
</tr>
<tr>
    <td>Sabado</td>
    <td style="text-align: center;">{{horarios.sabado.inicio}}</td>
    <td style="text-align: center;">{{horarios.sabado.fin}}</td>
</tr>
<tr>
    <td>Domingo</td>
    <td style="text-align: center;">{{horarios.domingo.inicio}}</td>
    <td style="text-align: center;">{{horarios.domingo.fin}}</td>
</tr>

</table>-->

<table class="simple">
    <thead>
        <tr>
            <th>Día</th>
            <th>Hora Inicio</th>
            <th>Hora Término</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <small> Lunes </small>
            </td>
            <td>
                <small>
                    {{ horarios?.lunes?.inicio ? horarios.lunes.inicio : "-" }}
                </small>
            </td>
            <td>
                <small>
                    {{ horarios?.lunes?.fin ? horarios.lunes.fin : "-" }}
                </small>
            </td>
        </tr>
        <tr>
            <td>
                <small> Martes </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.martes?.inicio ? horarios.martes.inicio : "-"
                    }}
                </small>
            </td>
            <td>
                <small>
                    {{ horarios?.martes?.fin ? horarios.martes.fin : "-" }}
                </small>
            </td>
        </tr>
        <tr>
            <td>
                <small> Míércoles </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.miercoles?.inicio
                            ? horarios.miercoles.inicio
                            : "-"
                    }}
                </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.miercoles?.fin ? horarios.miercoles.fin : "-"
                    }}
                </small>
            </td>
        </tr>
        <tr>
            <td>
                <small> Jueves </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.jueves?.inicio ? horarios.jueves.inicio : "-"
                    }}
                </small>
            </td>
            <td>
                <small>
                    {{ horarios?.jueves?.fin ? horarios.jueves.fin : "-" }}
                </small>
            </td>
        </tr>
        <tr>
            <td>
                <small> Viernes </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.viernes?.inicio
                            ? horarios.viernes.inicio
                            : "-"
                    }}
                </small>
            </td>
            <td>
                <small>
                    {{ horarios?.viernes?.fin ? horarios.viernes.fin : "-" }}
                </small>
            </td>
        </tr>
        <tr>
            <td>
                <small> Sábado </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.sabado?.inicio ? horarios.sabado.inicio : "-"
                    }}
                </small>
            </td>
            <td>
                <small>
                    {{ horarios?.sabado?.fin ? horarios.sabado.fin : "-" }}
                </small>
            </td>
        </tr>
        <tr>
            <td>
                <small> Domingo </small>
            </td>
            <td>
                <small>
                    {{
                        horarios?.domingo?.inicio
                            ? horarios.domingo.inicio
                            : "-"
                    }}
                </small>
            </td>
            <td>
                <small>
                    {{ horarios?.domingo?.fin ? horarios.domingo.fin : "-" }}
                </small>
            </td>
        </tr>
    </tbody>
</table>
